// extracted by mini-css-extract-plugin
export default {"responses":"aCtON","response":"e6SMi"};